import React from 'react';
import {
    Show,
    TabbedShowLayout,
    TextField,
    Tab,
    ReferenceManyField,
    Datagrid, ReferenceField
} from 'react-admin';

const GrupoValidacionesShow = (props) => (
  <Show {...props}>
      <TabbedShowLayout>
          <Tab label="resources.grupo-validaciones.tabs.general">
              <TextField source="descripcion" label="resources.grupo-validaciones.fields.descripcion" />
          </Tab>
          <Tab label="resources.grupo-validaciones.tabs.prestaciones">
              <ReferenceManyField
                  addLabel={false}
                  reference="prestacion-grupo-validaciones"
                  source="id"
                  target="idGrupoValidaciones"
                  sort={{ field: "idPrestacion", order: "DESC" }}
                  filter={{ deleted: false }}
              >
                  <Datagrid rowClick="show">
                      <TextField source="idPrestacion" label="resources.grupo-validaciones.fields.id"/>
                      <ReferenceField
                          label="resources.grupo-regla.fields.descripcion"
                          source="idPrestacion"
                          reference="prestaciones"
                          link={false}
                      >
                          <TextField source="descripcion" />
                      </ReferenceField>
                  </Datagrid>
              </ReferenceManyField>
          </Tab>
      </TabbedShowLayout>
  </Show>
);

export default GrupoValidacionesShow;
